import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=3d82233e&scoped=true&"
import script from "./domain.vue?vue&type=script&lang=js&"
export * from "./domain.vue?vue&type=script&lang=js&"
import style0 from "./domain.vue?vue&type=style&index=0&id=3d82233e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d82233e",
  null
  
)

export default component.exports